// export const BASE_URL ="http://3.110.120.207"
export const BASE_URL = "https://pospbackend.risify.in/v1";

// export const INSURANCE_URL = "https://backend.analahinsure.com/v1";
export const INSURANCE_URL = "https://backend.risify.in/v1";
